import { render, staticRenderFns } from "./fixedright.vue?vue&type=template&id=fe4b20ae&scoped=true"
import script from "./fixedright.vue?vue&type=script&lang=js"
export * from "./fixedright.vue?vue&type=script&lang=js"
import style0 from "./fixedright.vue?vue&type=style&index=0&id=fe4b20ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe4b20ae",
  null
  
)

export default component.exports